import { Button, Grid, TextField } from "@mui/material";
import React, { useContext } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { EDIT_APPOINTMENT } from "../../../enums/PermissionTitles";
import { snackbarSeverity } from "../../../hooks/useSnackbar";
import useSubmit from "../../master/species/hooks/useSubmit";

// With formId the form has no Save button of its own and is submitted by a dialog's Save
export default function BiometricsForm({ queryKey, apiKey, id, onSuccess, formId }) {
  const { control, handleSubmit, reset } = useFormContext();
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const { isPermissionAllowed } = useContext(GlobalDataContext);

  function isEmpty(obj) {
    return Object.values(obj).every((x) => x === null || x === "");
  }

  const submittion = useSubmit(null, apiKey + id, queryKey, [queryKey]);

  const submitData = async (data) => {
    if (!isEmpty(data)) {
      const saved = submittion.submitCallback(data);
      reset();
      if (onSuccess && (await saved)) onSuccess();
    } else {
      handleSnackbar("PleaseInputBiometricsData", snackbarSeverity.ERROR);
    }
  };

  return (
    <form id={formId} onSubmit={handleSubmit(submitData)}>
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} sm={4}>
          <Controller
            name="temperature"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                label={t("BodyTemperature")}
                fullWidth
                inputProps={{ maxLength: 20 }}
                data-testid="pet.biometrics.add-form.temperature-input" 
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="heartRate"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                label={t("Puls/Min")}
                fullWidth
                inputProps={{ maxLength: 20 }}
                data-testid="pet.biometrics.add-form.heart-rate-input" 
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="weight"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                label={t("Mass")}
                fullWidth
                inputProps={{ maxLength: 20 }}
                data-testid="pet.biometrics.add-form.weight-input" 
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="breathingFrequency"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                label={t("FrequencyOfBreathing")}
                fullWidth
                inputProps={{ maxLength: 20 }}
                data-testid="pet.biometrics.add-form.breathing-frequency-input" 
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="length"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                label={t("length")}
                fullWidth
                inputProps={{ maxLength: 20 }}
                data-testid="pet.biometrics.add-form.length-input" 
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="height"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                label={t("height")}
                fullWidth
                inputProps={{ maxLength: 20 }}
                data-testid="pet.biometrics.add-form.height-input" 
              />
            )}
          />
        </Grid>
        {!formId && (
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            disabled={!isPermissionAllowed(EDIT_APPOINTMENT)}
            data-testid="pet.biometrics.add-form.save-button" 
            sx={{ width: 150 }}
          >
            {t("Save")}
          </Button>
        </Grid>
        )}
      </Grid>
    </form>
  );
}
